import React, { useState } from "react";
// import Gallery from "../../images/image-files.png";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
const EasyCrop = ({ setImage }) => {
  const [cropData, setCropData] = useState("");
  const [cropper, setCropper] = useState(null);

  const onChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setCropData(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      console.log(cropper);
      setCropData(cropper.getCroppedCanvas().toDataURL());
      console.log("cropped data", cropData);
      setImage(cropData);
    }
  };

  // const cancelCrop = () => {
  //   setCropData("");
  // };

  // const handleSaveClick = () => {
  //   if (cropData) {
  //     // Create a new anchor element
  //     const downloadLink = document.createElement("a");
  //     // Set the href attribute to the base64 data URI
  //     downloadLink.href = cropData;
  //     // Set the download attribute to the filename
  //     downloadLink.download = "croppedImage.png";

  //     // Show a success message
  //     alert("Image saved successfully!");
  //   }
  // };

  return (
    <div className="flex justify-center items-center bg-gray-100">
      <div className="flex w-full p-2">
        <div className="w-full">
          <div className="p-4 border rounded-md">
            <input
              type="file"
              onChange={onChange}
              className="hidden"
              id="fileInput"
            />
            <div className="flex justify-between items-center mb-4">
              <label
                htmlFor="fileInput"
                className="px-4 py-2 text-xs bg-indigo-600 text-white rounded-md cursor-pointer"
              >
                Select Image
              </label>
            </div>
            <Cropper
              className="w-full h-64"
              // zoomTo={0.5}
              // initialAspectRatio={1}
              src={cropData}
              viewMode={1}
              minCropBoxHeight={10}
              minCropBoxWidth={10}
              background={false}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false}
              onInitialized={(instance) => {
                setCropper(instance);
              }}
              guides={true}
            />
            <div className="flex justify-between items-center mt-4">
              <button
                type="button"
                onClick={getCropData}
                className=" bg-indigo-600 p-2 text-white text-xs rounded-md cursor-pointer"
              >
                Upload Image
              </button>
              {/* {cropData && (
                <button
                  type="button"
                  onClick={cancelCrop}
                  className="p-2 bg-gray-200 rounded-md cursor-pointer text-xs"
                >
                  Cancel
                </button>
              )} */}
              {/* <button
                type="button"
                onClick={handleSaveClick}
                className="p-2 bg-green-600 text-xs text-white rounded-md cursor-pointer"
              >
                Save
              </button> */}
            </div>
          </div>
        </div>
        {/* <div className="w-1/2">
          <div className="p-4 border rounded-md">
            {cropData ? (
              <img className="w-full" src={cropData} alt="cropped" />
            ) : (
              <h1 className="text-center text-xs text-gray-500">
                Cropped image!
              </h1>
            )}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default EasyCrop;
